import { Box, Stack } from '@mui/material';

import FormField from 'components/common/formikForm/formField';
import FormGridLayout from 'components/common/formikForm/formGridLayout';

interface SignatureMetadataFieldsProps {
    disabled?: boolean;
    showDefault?: boolean;
    /** stack = single column (edit dialog); grid = side-by-side (create form) */
    layout?: 'stack' | 'grid';
}

export function SignatureMetadataFields({
    disabled = false,
    showDefault = true,
    layout = 'stack',
}: SignatureMetadataFieldsProps) {
    const fields = (
        <>
            <FormField
                name="display_name"
                label="Display Name"
                disabled={disabled}
                placeholder="e.g., Dr. John Smith"
            />
            <FormField
                name="title"
                label="Professional Title"
                disabled={disabled}
                placeholder="e.g., RCIC, Immigration Consultant"
            />
            <FormField
                name="signature_name"
                label="Signature Name"
                disabled={disabled}
                placeholder="e.g., Formal Signature"
            />
            {showDefault ? (
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        minHeight: { sm: layout === 'grid' ? 40 : undefined },
                        pt: layout === 'grid' ? { sm: 0.5 } : 0,
                    }}
                >
                    <FormField
                        name="is_default"
                        label="Set as default signature"
                        type="checkbox"
                        disabled={disabled}
                    />
                </Box>
            ) : null}
        </>
    );

    if (layout === 'grid') {
        return <FormGridLayout>{fields}</FormGridLayout>;
    }

    return <Stack spacing={1}>{fields}</Stack>;
}

export default SignatureMetadataFields;
